import { z } from 'zod'

export const taxRegimeValues = [
  'simple_national',
  'simple_national_excess',
  'normal_assumed_profit_or_actual_profit',
  'normal_assumed_profit',
] as const

const TaxRegimeTypesEnum = z.enum(taxRegimeValues)

export const taxRegimeLabelMap = {
  [TaxRegimeTypesEnum.Values.simple_national]: 'Simples Nacional',
  [TaxRegimeTypesEnum.Values.simple_national_excess]:
    'Simples Nacional Excesso',
  [TaxRegimeTypesEnum.Values.normal_assumed_profit_or_actual_profit]:
    'Normal - Lucro Presumido ou Real',
  [TaxRegimeTypesEnum.Values.normal_assumed_profit]: 'Normal - Lucro Presumido',
} as const
